export function loadOpenAiPixel({ pixelId }) {
  // Make sure we only initialize the pixel once.
  let oaiq = window.oaiq;
  if (oaiq) {
    return oaiq;
  }

  // Integration code provided by OpenAI.
  // After this function runs, window.oaiq will be defined
  // and should be returned to the caller.
  (function (w, d, s, u) {
    if (w.oaiq) return;
    var q = function () {
      q.q.push(arguments);
    };
    q.q = [];
    w.oaiq = q;
    var js = d.createElement(s);
    js.async = true;
    js.src = u;
    var f = d.getElementsByTagName(s)[0];
    f.parentNode.insertBefore(js, f);
  })(window, document, 'script', 'https://bzrcdn.openai.com/sdk/oaiq.min.js');

  oaiq = window.oaiq;
  oaiq('init', { pixelId });

  return oaiq;
}

/**
 * Reports a completed purchase to OpenAI ads so ChatGPT-ad-attributed orders
 * show up in their reporting. No-op when no pixel id is configured.
 *
 * `value` is in dollars, like the gtag/fbq purchase events; OpenAI wants the
 * total as an integer in the currency's minor unit, so $25.99 becomes 2599.
 * The order id goes in `event_id`, which is what OpenAI dedupes on.
 */
export function sendOpenAiOrderEvent({ orderId, value, currency, items }) {
  const pixelId =
    window.ReactAppEnv &&
    window.ReactAppEnv.stats &&
    window.ReactAppEnv.stats.openAiPixelId;

  if (!pixelId) {
    return;
  }

  const oaiq = loadOpenAiPixel({ pixelId });
  oaiq(
    'measure',
    'order_created',
    {
      type: 'contents',
      amount: Math.round(value * 100),
      currency,
      contents: items.map((item) => ({
        id: item.item_id,
        name: item.item_name,
        content_type: 'product',
        quantity: item.quantity,
      })),
    },
    { event_id: orderId },
  );
}
